import { render, staticRenderFns } from "./rubric_with_grading_details_form.vue?vue&type=template&id=727deb66&scoped=true&"
import script from "./rubric_with_grading_details_form.vue?vue&type=script&lang=js&"
export * from "./rubric_with_grading_details_form.vue?vue&type=script&lang=js&"
import style0 from "./rubric_with_grading_details_form.vue?vue&type=style&index=0&id=727deb66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727deb66",
  null
  
)

export default component.exports